import * as Sentry from '@sentry/react';

const INFO_USER_STORAGE_KEY = 'info_user';

interface SentrySessionUser {
	id: string;
	name?: string;
	email?: string;
}

interface SentryUserSession {
	user?: SentrySessionUser;
}

export function setSentryUser(session: SentryUserSession | null): void {
	const user = session?.user;

	if (!user?.id) {
		return;
	}

	Sentry.setUser({ id: user.id, email: user.email, username: user.name });
}

export function clearSentryUser(): void {
	Sentry.setUser(null);
}

export function identifySentryUserFromStorage(): void {
	const stored = localStorage.getItem(INFO_USER_STORAGE_KEY);

	if (!stored) {
		return;
	}

	try {
		const session = JSON.parse(stored) as SentryUserSession;
		setSentryUser(session);
	} catch {
		return;
	}
}
